module.exports = __webpack_public_path__ + "fonts/benchnine-v9-latin-regular.0c250d7f.eot";